import { State } from '@/types/State';
import { createSlice } from '@reduxjs/toolkit';
import { find, get } from 'lodash';

const routesSlice = createSlice({
  name: 'routes',
  initialState: {
    routes: null,
  },
  reducers: {
    setRoutes: (state, action) => {
      state.routes = action.payload;
    },
  },
});

export const { setRoutes } = routesSlice.actions;

export const getRoutePath = (
  state: State,
  utilityTypeName: string,
  meteringPointTypeName: string,
) => {
  const routes = state.routes.routes;

  if (utilityTypeName === 'EL' && meteringPointTypeName === 'PRODUCTION') {
    return '/el/eloverskott';
  }

  if (utilityTypeName === 'PP' && meteringPointTypeName === 'CONSUMPTION') {
    return '/el/effekttopp-elnat';
  }

  return get(
    find(
      routes,
      (route) =>
        route.infraService && route.infraService.indexOf(utilityTypeName) > -1,
    ),
    'path',
  );
};

export default routesSlice.reducer;
